import { render, staticRenderFns } from "./DialogMediaWarning.vue?vue&type=template&id=1e36821b&"
import script from "./DialogMediaWarning.vue?vue&type=script&lang=js&"
export * from "./DialogMediaWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports